// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1NFOK","label":"Category_label__DV7dH","content":"Category_content__2X1II","header":"Category_header__280_p","location":"Category_location__2SsgG"};